module.exports = __webpack_public_path__ + "static/media/faq_closed.7d7733d0.svg";